// react
import React from 'react';
import styled from 'styled-components';

// components
import { Button } from '@/components/atoms';

/**
 * JourneyFiller gives the user a brief summary of the action they just
 * performed as well as a button to progress to the next stage.
 */
export const JourneyFiller = ({
  title,
  description,
  actionLabel,
  onAction,
}: JourneyFillerProps) => {
  return (
    <StyledJourneyFiller>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Button
        ariaLabel={actionLabel}
        onPress={onAction}
        iconRight={'long-arrow-right'}
        size='md'
      >
        {actionLabel}
      </Button>
    </StyledJourneyFiller>
  );
};

const StyledJourneyFiller = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
  width: 100%;
  align-items: center;
`;

const Title = styled.div`
  font: ${(props) => props.theme.typography.heading['4xl']};
  color: ${(props) => props.theme.color.primary[80]};
`;

const Description = styled.div`
  font: ${(props) => props.theme.typography.heading['2xl']};
  color: ${(props) => props.theme.color.neutral[90]};
`;

interface JourneyFillerProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}

JourneyFiller.displayName = 'JourneyFiller';

export default JourneyFiller;
